interface LoadContainerOpts {}

export default async (
	el: HTMLElement,
	$el: JQuery<HTMLElement>,
	opt: LoadContainerOpts,
) => {

    const scrollOffset = 100
    const animationDuration = 300

    $el.on('click', () => {
        scrollTo({
			top: 0,
			behavior: 'smooth',
		})
    })

    $(window).on('scroll', () => {
        if (window.scrollY > scrollOffset) {
            if ($el.hasClass('hidden')) {
				// Show back to top btn
				$el.removeClass('hidden')
				$el.addClass('flex')
				setTimeout(() => {
					$el.removeClass('opacity-0')
				}, 1)
			}
		} else {
			// Hide back to top btn
			if (!$el.hasClass('opacity-0')) {
                $el.removeClass('opacity-1')
				$el.addClass('opacity-0')
				setTimeout(() => {
					$el.removeClass('flex')
					$el.addClass('hidden')
				}, animationDuration)
			}
		}
    })

}
